import Http from '@/common/http'
class Utm {
  static getUtmGroupList (param = {}) {
    return Http.get('/data/utm/getUtmGroupList', param)
  }
  static getUtmList (param = {}) {
    return Http.get('/data/utm/getUtmList', param)
  }
  static getSummaryData (param = {}) {
    return Http.get('/data/utm/getSummaryData', param)
  }
  static getDetailData (param = {}) {
    return Http.get('/data/utm/getDetailData', param)
  }
  static getInsightInfo (param = {}) {
    return Http.get('/data/jd_data//getInsightInfo', param)
  }
}

class RealTime {
  static getOverviewChart (param = {}) {
    return Http.get('/data/mp_data/currentActiveUser', param)
  }
  static summaryTable (param = {}) {
    return Http.get('/data/mp_data/realtimeSummaryTable', param)
  }
}

class User {
  static getUserTotal (param = {}) {
    return Http.get('/data/mp_data/getUserTotal', param)
  }
  static getUserSceneTotal (param = {}) {
    return Http.get('/data/mp_data/getUserSceneTotal', param)
  }
  static getUserTotalByDate (param = {}) {
    return Http.get('/data/mp_data/getUserTotalByDate', param)
  }
  static getUserSceneByDate (param = {}) {
    return Http.get('/data/mp_data/getUserSceneByDate', param)
  }
  static getUserSceneDetailByDate (param = {}) {
    return Http.get('/data/mp_data/getUserSceneDetailByDate', param)
  }
  static getUserSubscribeSceneDetailByDate (param = {}) {
    return Http.get('/data/mp_data/getUserSubscribeSceneDetailByDate', param)
  }
  static getUserDetailFilter (param = {}) {
    return Http.get('/data/mp_data/getUserDetailFilter', param)
  }
  static getUserListByFilter (param = {}) {
    return Http.get('/data/mp_data/getUserListByFilter', param)
  }
  static getUserDetailSummary (param = {}) {
    return Http.get('/data/mp_data/getUserDetailSummary', param)
  }
  static getUserDetailLog (param = {}) {
    return Http.get('/data/mp_data/getUserDetailLog', param)
  }
}

class Behavior {
  static getBehaviorMpTotal (param = {}) {
    return Http.get('/data/mp_data/getBehaviorMpTotal', param)
  }
  static getBehaviorMenuAggs (param = {}) {
    return Http.get('/data/mp_data/getBehaviorMenuAggs', param)
  }
  static getBehaviorMessageAggs (param = {}) {
    return Http.get('/data/mp_data/getBehaviorMessageAggs', param)
  }
  static getMessageKeywordData (param = {}) {
    return Http.get('/data/mp_data/getMessageKeywordData', param)
  }
  static getMessageKeywordDetail (param = {}) {
    return Http.get('/data/mp_data/getMessageKeywordDetail', param)
  }
  static getTrackGroupList (param = {}) {
    return Http.get('/data/mp_data/getTrackGroupList', param)
  }
  static getTrackEventOfGroup (param = {}) {
    return Http.get('/data/mp_data/getTrackEventOfGroup', param)
  }
  static getTrackEventPageOfGroup (param = {}) {
    return Http.get('/data/mp_data/getTrackEventPageOfGroup', param)
  }
  static getTrackEventUrlOfGroup (param = {}) {
    return Http.get('/data/mp_data/getTrackEventUrlOfGroup', param)
  }
  static getTrackEventEventOfGroup (param = {}) {
    return Http.get('/data/mp_data/getTrackEventEventOfGroup', param)
  }
  static getRdGroupList (param = {}) {
    return Http.get('/data/mp_data/getRdGroupList', param)
  }
  static getTrackLinkOfGroup (param = {}) {
    return Http.get('/data/mp_data/getTrackLinkOfGroup', param)
  }
  static getArticleTotal (param = {}) {
    return Http.get('/data/mp_data/getArticleTotal', param)
  }
  static getArticleInfoByDate (param = {}) {
    return Http.get('/data/mp_data/getArticleInfoByDate', param)
  }
  static getBehaviorMenuDetailAggs (param = {}) {
    return Http.get('/data/mp_data/getBehaviorMenuDetailAggs', param)
  }
}

class Content {
  static getArticleInfoByDate (param = {}) {
    return Http.get('/data/mp_data/getArticleInfoByDate', param)
  }
  static getArticleHourInfoByDate (param = {}) {
    return Http.get('/data/mp_data/getArticleHourInfoByDate', param)
  }
}

class Mini {
  static getOverviewTotal (param = {}) {
    return Http.get('/data/sp_data/getOverviewTotal', param)
  }
  static getOverviewFromchannle (param = {}) {
    return Http.get('/data/sp_data/getOverviewFromchannle', param)
  }
  static getOverviewScene (param = {}) {
    return Http.get('/data/sp_data/getOverviewScene', param)
  }
  static getUserTotalByDate (param = {}) {
    return Http.get('/data/sp_data/getUserTotalByDate', param)
  }
  static getFromchannleByDate (param = {}) {
    return Http.get('/data/sp_data/getFromchannleByDate', param)
  }
  static getSceneByDate (param = {}) {
    return Http.get('/data/sp_data/getSceneByDate', param)
  }

  static getPvAndUv (param = {}) {
    return Http.get('/data/sp_data/getPvAndUv', param)
  }
  static getBehaviorScene (param = {}) {
    return Http.get('/data/sp_data/getBehaviorScene', param)
  }
  static getBehaviorRoute (param = {}) {
    return Http.get('/data/sp_data/getBehaviorRoute', param)
  }
  static getBehaviorFromchannle (param = {}) {
    return Http.get('/data/sp_data/getBehaviorFromchannle', param)
  }
  static getBehaviorCustom (param = {}) {
    return Http.get('/data/sp_data/getBehaviorCustom', param)
  }
  static getShareSummary (param = {}) {
    return Http.get('/data/sp_data/getShareSummary', param)
  }
  static getShareRout (param = {}) {
    return Http.get('/data/sp_data/getShareRout', param)
  }

  static getRealtimeFromchannle(param = {}) {
    return Http.get('/data/sp_data/getRealtimeFromchannle', param)
  }
  static getBehaviorFromchannleDetail(param = {}) {
    return Http.get('/data/sp_data/getBehaviorFromchannleDetail', param)
  }
  static getRealtimeActive (param = {}) {
    return Http.get('/data/sp_data/getRealtimeActive', param)
  }
  static getRealtimeActiveScene (param = {}) {
    return Http.get('/data/sp_data/getRealtimeActiveScene', param)
  }
  static getBehaviorSceneDetail (param = {}) {
    return Http.get('/data/sp_data/getBehaviorSceneDetail', param)
  }
  static getRealtimeActiveRoute (param = {}) {
    return Http.get('/data/sp_data/getRealtimeActiveRoute', param)
  }
  static getBehaviorRouteDetail (param = {}) {
    return Http.get('/data/sp_data/getBehaviorRouteDetail', param)
  }
  static getBehaviorCustomDetail (param = {}) {
    return Http.get('/data/sp_data/getBehaviorCustomDetail', param)
  }
  static getFilterCriteria (param = {}) {
    return Http.get('/data/sp_data/getFilterCriteria', param)
  }
  static getUserListByFilter (param = {}) {
    return Http.get('/data/sp_data/getUserListByFilter', param)
  }
  static getUserDetailSummary (param = {}) {
    return Http.get('/data/sp_data/getUserDetailSummary', param)
  }
  static getUserDetailLog (param = {}) {
    return Http.get('/data/sp_data/getUserDetailLog', param)
  }
}

class Miniv2 {
  static getOverviewTotal (param = {}) {
    return Http.get('/data/sp_data_v2/getOverviewTotal', param)
  }
  static getOverviewFromchannle (param = {}) {
    return Http.get('/data/sp_data_v2/getOverviewFromchannle', param)
  }
  static getOverviewScene (param = {}) {
    return Http.get('/data/sp_data_v2/getOverviewScene', param)
  }
  static getUserTotalByDate (param = {}) {
    return Http.get('/data/sp_data_v2/getUserTotalByDate', param)
  }
  static getFromchannleByDate (param = {}) {
    return Http.get('/data/sp_data_v2/getFromchannleByDate', param)
  }
  static getSceneByDate (param = {}) {
    return Http.get('/data/sp_data_v2/getSceneByDate', param)
  }

  static getPvAndUv (param = {}) {
    return Http.get('/data/sp_data_v2/getPvAndUv', param)
  }
  static getBehaviorScene (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorScene', param)
  }
  static getBehaviorRoute (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorRoute', param)
  }
  static getBehaviorFromchannle (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorFromchannle', param)
  }
  static getBehaviorCustom (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorCustom', param)
  }
  static getShareSummary (param = {}) {
    return Http.get('/data/sp_data_v2/getShareSummary', param)
  }
  static getShareRout (param = {}) {
    return Http.get('/data/sp_data_v2/getShareRout', param)
  }

  static getRealtimeFromchannle(param = {}) {
    return Http.get('/data/sp_data_v2/getRealtimeFromchannle', param)
  }
  static getBehaviorFromchannleDetail(param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorFromchannleDetail', param)
  }
  static getRealtimeActive (param = {}) {
    return Http.get('/data/sp_data_v2/getRealtimeActive', param)
  }
  static getRealtimeActiveScene (param = {}) {
    return Http.get('/data/sp_data_v2/getRealtimeActiveScene', param)
  }
  static getBehaviorSceneDetail (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorSceneDetail', param)
  }
  static getRealtimeActiveRoute (param = {}) {
    return Http.get('/data/sp_data_v2/getRealtimeActiveRoute', param)
  }
  static getBehaviorRouteDetail (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorRouteDetail', param)
  }
  static getBehaviorCustomDetail (param = {}) {
    return Http.get('/data/sp_data_v2/getBehaviorCustomDetail', param)
  }
  static getFilterCriteria (param = {}) {
    return Http.get('/data/sp_data_v2/getFilterCriteria', param)
  }
  static getUserListByFilter (param = {}) {
    return Http.get('/data/sp_data_v2/getUserListByFilter', param)
  }
  static getUserDetailSummary (param = {}) {
    return Http.get('/data/sp_data_v2/getUserDetailSummary', param)
  }
  static getUserDetailLog (param = {}) {
    return Http.get('/data/sp_data_v2/getUserDetailLog', param)
  }
}

export default {
  RealTime,
  Utm,
  User,
  Behavior,
  Content,
  Mini,
  Miniv2
}
